import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationsKey } from '../../utils/keys';
export const useMemberInvitations = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const memberInvitationsKey = getMemberInvitationsKey(variables);
    return useInfiniteQuery(memberInvitationsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.invitations.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useMemberInvitations.js.map